import Vivus from "vivus";

export class Main {
  constructor() {
    this.heroesInview = true; //再生中かどうか
    this.heroesBottomY = 0;
    this.heroesElem = {};
    this.interval = {}; //heroesのアニメーション(translateY)のため
    this.windowWidth = 0;
    this.windowHeight = 0;

    this.handler = {};
    this.loop = {};
  }

  setProps(el, props) {
    for (let key in props) {
      el.style.setProperty("--" + key, props[key]);
    }
  }

  clamp(v, min, max) {
    return min > v ? min : max < v ? max : v;
  }

  // heroesのアニメーション
  loopFactry(func) {
    //funcで実行する関数を指定される

    //console.log(this.windowWidth);
    //let i = 0;
    this.handler = {};
    this.loop = () => {
      //i = func(i);
      //func(this);
      this.loopFunc();
      this.handler.id = requestAnimationFrame(this.loop);
    };
    this.handler.id = requestAnimationFrame(this.loop);
    return this.handler;
  }

  loopFunc() {
    //console.log(this.heroesElem);
    //console.log(document.documentElement.clientWidth);

    this.windowWidth = document.documentElement.clientWidth;
    this.windowHeight = document.documentElement.clientHeight;

    // if (document.getElementById("js-recruit__heroes")) {
    //   let heroes = document.getElementById("js-recruit__heroes").querySelectorAll("ul li");
    //   [].forEach.call(heroes, (elem) => {
    //     let myX = elem.getBoundingClientRect().left;
    //     let myWidth = elem.getBoundingClientRect().width;
    //     //let myXPer = this.clamp(myX, 0, this.windowWidth)/this.windowWidth;

    //     let angle = 7;
    //     let radians = angle * (Math.PI / 180);
    //     let transY = Math.sin(radians) * myX;

    //     if (myX > 1.2 * this.windowWidth || myX < -1.5 * myWidth) {
    //       transY = 0;
    //     }
    //     let props = {
    //       "trans-y": transY,
    //     };
    //     this.setProps(elem, props);
    //   });
    // }
  }

  // 初期化
  init() {
    window.addEventListener("DOMContentLoaded", () => {
      this.body = document.getElementsByTagName("body")[0];
      this.html = document.getElementsByTagName("html")[0];
      //   this.windowWidth = document.documentElement.clientWidth;
      //   this.windowHeight = document.documentElement.clientHeight;

      // ウインドウリサイズ時
      //   window.addEventListener("resize", () => {
      //   });

      // スクロール時
      window.addEventListener("scroll", () => {
        // ヒーローセクションが画面内かどうか
        if (document.getElementById("js-recruit__heroes")) {
          this.heroesElem = document.getElementById("js-recruit__heroes");
          this.heroesBottomY = this.heroesElem.getBoundingClientRect().bottom;
          if (this.heroesBottomY < 0) {
            this.heroesInview = false;
            this.heroesElem.classList.remove("is-show");
          } else {
            this.heroesInview = true;
            this.heroesElem.classList.add("is-show");
          }
        }
        //console.log(this.heroesBottomY, this.heroesInview);
      });

      // loop start;
      if (document.getElementById("js-recruit__heroes")) {
        this.interval = this.loopFactry(this.loopFunc);
      }
      // add listner to window to cancel loop;
      // window.onclick = function(){
      //     cancelAnimationFrame(interval.id);
      // };
    });

    // load時
    // ------------------------------
    window.addEventListener("load", () => {
      new Vivus("recruit-nav__illust", {
        duration: 240,
        file: "/wp-content/themes/liaison/assets/images/recruit/illust-recruit-menu-bg-2.svg",
        onReady: function (myVivus) {
          // `el` property is the SVG element
          myVivus.el.setAttribute("height", "auto");
        },
      });
    });
  }
}
